import { useEffect, useState } from "react";

import SectionHeader from "components/Meta/SectionHeader";
import FullTable from "components/MeTable/FullTable";
import NotesModalContent from "components/Meta/NotesModalContent";
import { useRecords } from "hooks/records";
import funcs from "tools/functions";

/**
 * @param {Array } ctxView
 * @param {Array} domain
 * @param {Function} onChangeView
 * @param {Array} parent
 * @return
 */

function QuickTable(props) {
  const { ctxView, parent, handleFilter, returnFilter = false } = props;
  const { model } = ctxView;

  let _ctxView = ctxView;
  if (ctxView.note) {
    _ctxView = {
      ...ctxView,
      webtree: [
        ...ctxView.webtree,
        {
          name: "notes",
          type: "notes_cell",
          width: "5%",
        },
      ],
    };
  }
  const [domain, setDomain] = useState(props.domain);
  const [offset, setOffset] = useState(0);

  const limit = ctxView.limit ?? 100;
  const fields_names = funcs.getViewFields(ctxView, "list");

  if (ctxView.note) {
    fields_names.push(
      "notes.message",
      "notes.create_date",
      "notes.create_uid.rec_name",
      "notes.unread",
    );
  }
  if (props.activeSearch) {
    fields_names.push("rec_name");
  }
  const order = ctxView.orderBy;
  const { data, refetch, isLoading } = useRecords(
    model,
    domain,
    fields_names,
    order,
    limit,
    offset,
  );

  const searchables = [];
  for (const [field, attrs] of Object.entries(ctxView.webfields)) {
    if (attrs.searchable) {
      searchables.push({
        name: field,
        type: attrs.type,
      });
    }
  }

  const actionButtons = [];
  if (ctxView.table_action.includes("remove")) {
    const action = "remove";
    if (
      (Array.isArray(action) && action.includes(parent?.state)) ||
      action === true
    ) {
      if (!props.readOnly) {
        actionButtons.push("button_remove");
      }
    }
  }
  if (ctxView.table_action.includes("update")) {
    actionButtons.push("button_edit");
  }

  function onChangePage(_activePage) {
    setOffset((_activePage - 1) * limit);
  }

  function reloadRecords() {
    if (refetch) {
      refetch();
    }
  }

  const activeSearch = props.activeSearch || ctxView.activeSearch;
  const _countRecords = data ? data.length : 0;

  // This fix a bug in react-query v4
  const loading = isLoading && domain;
  // https://github.com/TanStack/query/issues/3584

  useEffect(() => {
    const dom = props.domain ?? ctxView.domain;
    setDomain(dom);
    if (props.reload) {
      refetch();
    }
  }, [ctxView.domain, props.domain, props.reload]);

  return (
    <div id="quick-table" className="w-full">
      <FullTable
        {...props}
        ctxView={_ctxView}
        records={data}
        isLoading={loading}
        limit={limit}
        offset={offset}
        countRecords={_countRecords}
        actionButtons={actionButtons}
        reloadRecords={reloadRecords}
        onChangePage={onChangePage}
      />
      {ctxView.note && <NotesModalContent onReload={refetch} />}
    </div>
  );
}

export default QuickTable;
